__turbopack_context__.v({
  "plantTrees": "QgA2nW_plantTrees",
  "shimmerBlue": "QgA2nW_shimmerBlue",
  "subscriptionDisclaimerDiv": "QgA2nW_subscriptionDisclaimerDiv",
});
